import { render, staticRenderFns } from "./user-recharge-list.vue?vue&type=template&id=b51f48cc&scoped=true&"
import script from "./user-recharge-list.vue?vue&type=script&lang=js&"
export * from "./user-recharge-list.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b51f48cc",
  null
  
)

export default component.exports